import {system_info,system_info_new} from '@/api/index.js'
import helper from '@/common/helper.js';
import store from '@/store';
export default async ({i18n})=>{
  const [res,resNew] = await Promise.all([system_info(),system_info_new()])
  if (res.data.code == 1) {
    const siteNew = (resNew && resNew.data) ? resNew.data : {}
    store.commit("system/updateSystem",{system:res.data,systemNew:siteNew})
    const messages = res.data.lang || {}
    const langPatch = (siteNew && siteNew.lang) ? siteNew.lang : {}
    for (const lang in messages) {
      if (Object.prototype.hasOwnProperty.call(messages, lang) && langPatch[lang]) {
        messages[lang] = { ...messages[lang], ...langPatch[lang] }
      }
      i18n.mergeLocaleMessage(lang, messages[lang]);
    }
    // locale / icon 初始化与刷新兜底：
    // - 首次进入：没有本地 lang 时，用后端默认 locale
    // - 刷新进入：本地已有 lang 时，也要根据当前 lang 从 alllang 同步 icon（否则侧边栏国旗会一直空）
    if (res.data.locale && !helper.getLang()) {
      i18n.locale = res.data.locale;
      helper.setLang(res.data.locale);
    }
    const allLang = res.data.alllang || [];
    helper.set('alllang', allLang);
    const currentLocale = helper.getLang() || i18n.locale || res.data.locale;
    const matched = Array.isArray(allLang)
      ? allLang.find(i => i && (i.value == currentLocale || i.label == currentLocale))
      : null;
    const icon =
      (matched && matched.icon) ||
      res.data.locale_flag ||
      helper.get('i18n_icon') ||
      '';
    helper.set('i18n_icon', icon);
    const idcRaw = Array.isArray(res.data.idc)
      ? res.data.idc
      : (res.data.data && Array.isArray(res.data.data.idc) ? res.data.data.idc : []);
    helper.set('idc', idcRaw.map(item=>({...item,label:`+${item.label}`})));
    helper.set('amount_decimal_point', res.data.amount_decimal_point);
    helper.set('i18n_messages', messages);
    const rulePayload = { ...(res.data.data || {}), ...(siteNew.site || {}) };
    helper.set('rule', rulePayload);
    if (siteNew.site) {
      helper.setHeadInfo(siteNew.site);
    }
  }
}